import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from './initialState'

const geolocationUsersSlice = createSlice({
  name: 'geolocationUsers',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const geolocationUsersActions = geolocationUsersSlice.actions
export const { reducer: geolocationUsersReducer } = geolocationUsersSlice
